var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"upgrade_package"},[_c('router-link',{attrs:{"to":'/app/company/payment-settings/active'}},[_vm._v("\n    "+_vm._s(_vm.$t('navigationCompany.paymentsettings'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }